import { type Upload } from '@air/redux-uploader';
import { getAssetPreviewType } from '@air/utils-clips';

export const isPreviewAvailable = ({ apiUploadData: { type, ext } }: Upload) => {
  const webClipType = getAssetPreviewType({ ext, type });
  return webClipType === 'photo' || webClipType === 'video';
};
